import { render } from "./DataTable.html?vue&type=template&id=ec55f38e&scoped=true"
import script from "./DataTable.js?vue&type=script&lang=js"
export * from "./DataTable.js?vue&type=script&lang=js"

import "./DataTable.css?vue&type=style&index=0&id=ec55f38e&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec55f38e"]])

export default __exports__